import React from 'react';
import './App.css';

function Forms() {
  return (
    <div className="Forms">
      <div className="Formulario">
        <div className="page-title-forms"><h1>REEPAS</h1></div>
        <div className="forms-info">
        <p>Te invitamos a recibir en tu correo el reporte económico semanal al cuál si le vas a entender, y se enfoca en explicar y documentar de manera amena, con un lenguaje coloquial y entendible, libre de tecnicismos y relleno, los sucesos económicos de la semana. </p>
        <p>Enfocándonos no sólo en la veracidad, sino en la practicidad y utilidad de la información.</p> 
        <p>Ya sabemos que lees GBM, Bloomberg, etc. Pero también sabemos que con mucho esfuerzo, entiendes o comprendes de forma efectiva solamente un 30% de la información. Sabemos que quieres el Bottom Line, o qué impacto tiene en tu vida, por eso te invitamos a recibir el REEPAS.</p>
        </div>
        <div className="forms">
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfcMPtgMv3UBPTGzWocPTH1MllhJ-51xrBZK_1pBVQo-glweA/viewform?embedded=true" width="640" height="596" frameborder="0" marginheight="0" marginwidth="0">Cargando…</iframe>
        </div>
      </div>
    </div>
  );
}

export default Forms;